import { useState, useEffect } from "react";
import { FaAngleLeft, FaAngleRight, FaDownload } from 'react-icons/fa';
import axiosInstance from "../apis/axiosInstance";
import { useParams } from "react-router-dom";
import { decryptID } from '../apis/cryptoUtils';
import { postLead } from "../apis/LeadAPI";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";


const ProductDetails = () => {
    const { subcatid } = useParams();
    const decryptedSubcatId = decryptID(subcatid);
    const [selectedProduct, setselectedProduct] = useState(null);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [productDetails, setProductDetails] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedCategoryname, setSelectedCategoryname] = useState("");
    const [selectedSubCategoryname, setSelectedSubCategoryname] = useState("");
    const [selectedProductId, setSelectedProductId] = useState("");

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axiosInstance.get('https://infrec.in/php-backend/backend/product/get-products.php');
                console.log("Fetched all products:", response.data);
                console.log("Looking for subcatid:", subcatid);
                const filtered = response.data.filter(p => p.subcategory_id == decryptedSubcatId || (p.sub_category_name && p.sub_category_name.toLowerCase() === decryptedSubcatId.toLowerCase()));
                console.log("Filtered products:", filtered);
                filtered.forEach(p => console.log("Product image URL:", p.image));
                setProductDetails(filtered);
            } catch (error) {
                console.error("Error fetching product data:", error);
            }
        };
        if (subcatid) fetchData();
    }, [subcatid]);

    const handleApplyClick = (product, Categoryname, subCategoryname, productId) => {
        setselectedProduct(product);
        setSelectedCategoryname(Categoryname);
        setSelectedSubCategoryname(subCategoryname);
        setSelectedProductId(productId);
        setIsDrawerOpen(true);
    };

    const closeDrawer = () => {
        setIsDrawerOpen(false);
        setselectedProduct(null);
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);

        const leadData = {
            name: event.target.name.value,
            email: event.target.email.value,
            mobile: event.target.contactNumber.value,
            category_name: selectedCategoryname,
            subcategory_name: selectedSubCategoryname ? Number(selectedSubCategoryname) : null,
            product_id: selectedProductId ? Number(selectedProductId) : null,
        };

        const response = await postLead(leadData);
        setIsLoading(false);

        if (response.leadId) {
            toast.success(response.message);
            closeDrawer();
        } else {
            toast.error("Something went wrong");
        }
    };

    const products = productDetails.map(product => ({
        id: product.id,
        name: product.name,
        hyperlink: product.hyperlink,
        image: product.image,
        pdf: product.brochure_pdf,
        category_id: product.category_id,
        subcategory_id: product.subcategory_id,
        plan_id: product.plan_id,
        plan_name: product.plan_name,
    }));

    const groupedProducts = {};
    products.forEach(product => {
        const key = product.plan_id || product.name;
        if (!groupedProducts[key]) {
            groupedProducts[key] = [];
        }
        groupedProducts[key].push(product);
    });

    const [carouselIndices, setCarouselIndices] = useState({});
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleNextGroup = (groupName) => {
        setCarouselIndices(prev => ({
            ...prev,
            [groupName]: ((prev[groupName] || 0) + 1) % groupedProducts[groupName].length
        }));
    };

    const handlePrevGroup = (groupName) => {
        setCarouselIndices(prev => ({
            ...prev,
            [groupName]: ((prev[groupName] || 0) - 1 + groupedProducts[groupName].length) % groupedProducts[groupName].length
        }));
    };

    return (
        <>
            <div className=" bg-gray-50">
                <div className="bg-darkBlue text-white py-12 px-6  text-center h-[45vh]">
                    <h1 className="text-4xl font-bold  pt-20">{productDetails?.[0]?.sub_category_name || "Products"}</h1>
                    <p className="text-lg">
                        Secure your future with our exclusive insurance plans.
                    </p>
                </div>
            </div>

            {productDetails.length > 0 ? Object.entries(groupedProducts).map(([planKey, planProducts]) => (
                <div key={planKey} className="relative m-20 w-full max-w-7xl mx-auto">
                    <h2 className="text-2xl font-bold mb-6">{planProducts[0]?.plan_name || `Plan ${planKey}`}</h2>
                    <div className="relative">
                        <div className="overflow-hidden">
                            <div
                                className="flex transition-transform duration-500 ease-in-out"
                                style={{
                                    transform: `translateX(-${(carouselIndices[planKey] || 0) * (isMobile ? 100 : 50)}%)`,
                                }}
                            >
                                {planProducts.map((product) => (
                                    <div key={product.id} className="w-full sm:w-full md:w-1/2 flex-shrink-0 px-2">
                                        <div className="relative">
                                            <img
                                                src={product.image}
                                                alt={product.name}
                                                className="w-full h-[50vh] md:h-[50vh] object-contain"
                                            />
                                            <div className="absolute bottom-0 left-0 w-full p-4 bg-gradient-to-t from-black to-transparent text-white">
                                                <p className="text-sm mb-2">{product.name}</p>
                                                <div className="flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0">
                                                    <button
                                                        onClick={() => handleApplyClick(
                                                            product,
                                                            productDetails?.[0]?.category_name,
                                                            productDetails?.[0]?.subcategory_name,
                                                            product.id
                                                        )}
                                                        className="w-full md:w-auto px-3 py-2 text-sm md:text-base font-medium border border-white text-white bg-darkBlue rounded-lg shadow hover:bg-blue-700 transition-all duration-200"
                                                    >
                                                        BUY
                                                    </button>

                                                    <a
                                                        href={product.pdf}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="flex items-center justify-center w-full md:w-auto px-4 py-2 text-sm md:text-base font-medium text-blue-600 bg-white border border-blue-600 rounded-lg shadow hover:bg-blue-100 focus:outline-none transition-all duration-200"
                                                    >
                                                        <FaDownload className="mr-2" />
                                                        Download PDF
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {planProducts.length > 1 && (
                            <>
                                <button className="absolute top-1/2 left-0 -translate-y-1/2 text-white p-2 rounded-full" onClick={() => handlePrevGroup(planKey)}>
                                    <FaAngleLeft style={{ fontSize: '25px' }} />
                                </button>
                                <button className="absolute top-1/2 right-0 -translate-y-1/2 text-white p-2 rounded-full" onClick={() => handleNextGroup(planKey)}>
                                    <FaAngleRight style={{ fontSize: '25px' }} />
                                </button>
                                <div className="flex justify-center mt-4 space-x-2">
                                    {planProducts.map((_, index) => (
                                        <button
                                            key={index}
                                            onClick={() => setCarouselIndices(prev => ({ ...prev, [planKey]: index }))}
                                            className={`w-3 h-3 rounded-full ${index === (carouselIndices[planKey] || 0) ? "bg-blue-600" : "bg-gray-400"}`}
                                        ></button>
                                    ))}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )) : <div className="text-center py-20 text-gray-500">No products found</div>}

            {isDrawerOpen && (
                <>
                    <div
                        className="fixed inset-0 bg-black bg-opacity-50 z-40"
                        onClick={closeDrawer}
                    ></div>

                    <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-11/12 max-w-3xl bg-white shadow-lg rounded-lg z-50 flex flex-col md:flex-row">
                        <button
                            onClick={closeDrawer}
                            className="absolute top-2 right-2 text-gray-600 hover:text-gray-900 text-xl"
                        >
                            ✖
                        </button>

                        <img
                            src={selectedProduct?.image}
                            alt={selectedProduct?.name}
                            className="w-full md:w-1/3 h-40 md:h-auto object-cover"
                        />

                        <div className="w-full md:w-2/3 p-4 md:p-6 overflow-y-auto max-h-[80vh]">
                            <h2 className="text-xl md:text-2xl font-bold mb-2 md:mb-4">{selectedProduct?.name}</h2>
                            <p className="text-gray-600 mb-4">Please fill out the form to buy this plan</p>
                            <form onSubmit={handleFormSubmit} className="space-y-3 md:space-y-4">
                                <div>
                                    <label htmlFor="name" className="block font-medium text-gray-700">
                                        Name
                                    </label>
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        required
                                        className="w-full border rounded-lg p-2 mt-1"
                                        placeholder="Enter your full name"
                                    />
                                </div>
                                <div>
                                    <label htmlFor="email" className="block font-medium text-gray-700">
                                        Email
                                    </label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        required
                                        className="w-full border rounded-lg p-2 mt-1"
                                        placeholder="Enter your email"
                                    />
                                </div>
                                <div>
                                    <label htmlFor="contactNumber" className="block font-medium text-gray-700">
                                        Contact Number
                                    </label>
                                    <input
                                        type="tel"
                                        id="contactNumber"
                                        name="contactNumber"
                                        required
                                        className="w-full border rounded-lg p-2 mt-1"
                                        placeholder="Enter your contact number"
                                    />
                                </div>
                                <div className="flex flex-col md:flex-row justify-end gap-2">
                                    <button
                                        type="button"
                                        onClick={closeDrawer}
                                        className="w-full md:w-auto px-4 py-2 border rounded-lg text-gray bg-skyBlue hover:bg-gray-100"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        disabled={isLoading}
                                        className="w-full md:w-auto px-4 py-2 bg-darkBlue text-white rounded-lg"
                                    >
                                        Submit Application
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </>
            )}

            <ToastContainer position="top-right" autoClose={3000} />
        </>
    );
};

export default ProductDetails;
